import React, { Component, ReactElement } from 'react'
import { LanguageContextProvider } from '../../React/Common/Contexts'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { UsersListFeatureGate } from '../Guards/UsersListFeatureGate'
import { UsersList } from '../Components/Organisms/UsersList/UsersList'

/**
 * Routed page wrapper for the Application Users list page.
 */
@Route(RouteID.USERS)
export class UsersListPage extends Component {
    /**
     * Renders the guarded routed page.
     *
     * @returns Application Users page component tree.
     */
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.USERS}>
                <UsersListFeatureGate>
                    <LanguageContextProvider>
                        <UsersList />
                    </LanguageContextProvider>
                </UsersListFeatureGate>
            </RouteGuard>
        )
    }
}
